export default __webpack_public_path__ + "1346b18e11d35d749e47e608225101ed.png";